module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "parallax"
  }), _vm._v(" "), _c('div', {
    staticClass: "container",
    attrs: {
      "id": "staff"
    }
  }, [_c('h2', [_vm._v(" Notre équipe ")]), _vm._v(" "), _c('div', {
    staticClass: "staff"
  }, [_c('div', {
    staticClass: "presentation"
  }, [_c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/images/fanny.jpg"),
      "alt": "Estéfania XARPELL, Vétérinaire"
    }
  })]), _vm._v(" "), _c('h3', [_vm._v("Estéfania XARPELL")]), _vm._v(" "), _c('p', [_vm._v("Diplomée de l'Ecole "), _c('strong', [_vm._v("Vétérinaire")]), _vm._v(" de Toulouse, CES de nutrition de\n          l'école "), _c('strong', [_vm._v("vétérinaire")]), _vm._v(" Maison Alfort, DU d'homéopathie de\n      la faculté de médecine de Marseille.")])]), _vm._v(" "), _c('div', {
    staticClass: "presentation"
  }, [_c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/images/ainhoa.jpg"),
      "alt": "Ainhoa XARPELL, Pharmacienne"
    }
  })]), _vm._v(" "), _c('h3', [_vm._v("Ainhoa XARPELL")]), _vm._v(" "), _c('p', [_vm._v("Diplômée de l'université de pharmacie de\n            Barcelone (UB), ingénieure\n            de l'école supérieure de chimie physique électronique\n            de Lyon (CPE Lyon)")])]), _vm._v(" "), _c('div', {
    staticClass: "presentation"
  }, [_c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/images/michel.jpg"),
      "alt": "Michel HEINZELMEIER, Relations client"
    }
  })]), _vm._v(" "), _c('h3', [_vm._v("Michel HEINZELMEIER")]), _vm._v(" "), _c('p', [_vm._v("Ingénieur, CAAE de l'IAE de Toulon")])]), _vm._v(" "), _c('div', {
    staticClass: "presentation"
  }, [_c('div', {
    staticClass: "imgF"
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/images/frederique.jpg"),
      "alt": "Frédérique CHADERAT, Responsable informatique"
    }
  })]), _vm._v(" "), _c('h3', [_vm._v("Frédérique CHADERAT")]), _vm._v(" "), _c('p', [_vm._v("Ingénieur. Responsable informatique")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-234f9654"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Fr/Staff.vue
// module id = 123
// module chunks = 0